import {
  FaInstagram,
  FaFacebook,
  FaEnvelope,
  FaLink,
  FaGlobe,
  FaGithub,
  FaLinkedinIn,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export default function (name, headerIcons) {
  const icons = {
    default: {
      Icon: FaLink,
      color: '#718096',
    },
    github: headerIcons
      ? {
          src: '/static/a9dffb6ae0a648e24fe06a27a2ab61a0/bxl-github.svg',
          color: '#2f4f4f',
          size: 20,
        }
      : {
          Icon: FaGithub,
          color: 'darkslategray',
        },
    twitter: {
      Icon: FaXTwitter,
      color: '#1E3050',
    },
    instagram: {
      Icon: FaInstagram,
      color: '#C13584',
    },
    linkedin: headerIcons
      ? {
          src: '/static/62da45048f37ef2f237ae7abc8863e91/bxl-linkedin.svg',
          color: '#2f4f4f',
          size: 20,
        }
      : {
          Icon: FaLinkedinIn,
          color: '#2867B2',
        },
    facebook: {
      Icon: FaFacebook,
      color: '#4267B2',
    },
    email: {
      Icon: FaEnvelope,
      color: '#718096',
    },
    website: {
      Icon: FaGlobe,
      color: 'darkslategray',
    },
    youtube: headerIcons
      ? {
          src: '/static/59a83973673bf9c1f948b296e6b167bf/bxl-youtube.svg',
          color: '#1da1f2',
          size: 20,
        }
      : {
          Icon: FaYoutube,
          color: 'red',
        },
  };

  return icons[name];
}
